import { Maximize2 } from 'lucide-react';

import { cn } from '@/lib/utils';
import { useFloatingWindowsStore } from '@/state/floatingWindows.store';

/**
 * Docked pill row for minimized windows. Bottom-right, stacked ABOVE the Sonner
 * toaster (which sits at `bottom-right offset 80px`) so restore pills and toasts
 * never overlap. Clicking a pill restores + focuses its window.
 */
export function MinimizedTaskbar() {
  const instances = useFloatingWindowsStore(s => s.instances);
  const restoreWindow = useFloatingWindowsStore(s => s.restoreWindow);

  const minimized = Object.values(instances).filter(i => i.minimized);
  if (minimized.length === 0) return null;

  return (
    <div className="pointer-events-auto fixed right-4 bottom-24 z-[195] flex max-w-[60vw] flex-wrap justify-end gap-2">
      {minimized.map(instance => (
        <button
          key={instance.id}
          type="button"
          onClick={() => restoreWindow(instance.id)}
          aria-label={`Restore ${instance.title}`}
          className={cn(
            'border-chariot-stroke bg-chariot-background-secondary text-chariot-text-primary',
            'hover:bg-chariot-background-primary flex items-center gap-2 rounded-md border px-3 py-1.5 text-sm shadow-lg transition-colors'
          )}
        >
          <span className="max-w-[180px] truncate">{instance.title}</span>
          <Maximize2 className="text-chariot-text-secondary h-3.5 w-3.5 shrink-0" />
        </button>
      ))}
    </div>
  );
}
